module.exports = __webpack_public_path__ + "media/guide_cancel.87236000.mp3";